var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImageLoad } from '@backrs_ui/common-ui/src/hooks/useImageLoad';
import { Box, Typography, Button } from '@mui/material';
var FIGMA_BUTTON_WIDTH = 212;
export var HeaderCTACard = function (_a) {
    var id = _a.id, title = _a.title, buttonText = _a.buttonText, buttonOnClick = _a.buttonOnClick, imageUrl = _a.imageUrl, rightContent = _a.rightContent;
    var image = useImageLoad(imageUrl);
    return (_jsxs(Box, { sx: containerSx, children: [_jsxs(Box, { sx: contentContainerSx, children: [_jsxs(Box, { sx: topRowSx, children: [rightContent, _jsx(Typography, { sx: titleSx, children: title })] }), _jsx(Button, { id: id, hierarchy: "Secondary gray", size: "md", onClick: buttonOnClick, sx: buttonSx, children: buttonText })] }), !image.imageError && (_jsx(Box, __assign({ component: "img", src: imageUrl, alt: "", sx: imageWithLoadSx(image.imageLoaded) }, image.imageProps)))] }));
};
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        backgroundColor: backrs.colors['Colors/Foreground/fg-primary'],
        borderRadius: backrs.radius['radius-xl'],
        display: 'flex',
        flexDirection: 'column',
        containerType: 'inline-size',
        overflow: 'hidden',
        paddingBottom: backrs.spacing['spacing-2xl'],
        position: 'relative',
    });
};
var contentContainerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        gap: backrs.spacing['spacing-xl'],
        alignItems: 'flex-start',
        paddingTop: backrs.spacing['spacing-2xl'],
        position: 'relative',
        height: '280px',
        zIndex: 1,
        '@container (min-width: 550px)': {
            height: '360px',
        },
        '@container (min-width: 600px)': {
            paddingTop: backrs.spacing['spacing-3xl'],
            px: backrs.spacing['spacing-4xl'],
        },
    });
};
var topRowSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: backrs.spacing['spacing-xs'],
        width: '100%',
        '@container (min-width: 480px)': {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
        },
    });
};
var titleSx = function (_a) {
    var typography = _a.typography, backrs = _a.backrs;
    return (__assign(__assign({ color: backrs.colors['Colors/Base/White'] }, typography['display-xs-semibold']), { alignSelf: 'flex-start', '@container (min-width: 480px)': {
            order: -1,
        }, '@container (min-width: 600px)': __assign({}, typography['display-md-semibold']) }));
};
var buttonSx = {
    width: {
        sm: "".concat(FIGMA_BUTTON_WIDTH, "px"),
    },
};
var imageWithLoadSx = function (loaded) {
    return function () { return ({
        pointerEvents: 'none',
        objectFit: 'contain',
        width: '100%',
        maxWidth: '740px',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        opacity: loaded ? 1 : 0,
        transition: 'opacity 0.3s ease-in-out',
    }); };
};
